import OverviewStep from './OverviewStep';
import PackagesStep from './PackagesStep';
import PricingStep from './PricingStep';
import ServicesStep from './ServicesStep';
import DeparturesStep from './DeparturesStep';
import AllocationsStep from './AllocationsStep';
import ItinerariesStep from './ItinerariesStep';
import AddonsStep from './AddonsStep';
import FaqsStep from './FaqsStep';
import ReviewStepPage from './ReviewStepPage';
import { WIZARD_STEP_CONFIG_KEYS } from '../constants';

const STEP_COMPONENTS = {
    overview: OverviewStep,
    packages: PackagesStep,
    pricing: PricingStep,
    services: ServicesStep,
    departures: DeparturesStep,
    allocations: AllocationsStep,
    itineraries: ItinerariesStep,
    addons: AddonsStep,
    faqs: FaqsStep,
    review: ReviewStepPage,
};

/**
 * Renders the active wizard step page by config key / index.
 */
export function renderWizardStep(stepIndex, props) {
    const stepKey = WIZARD_STEP_CONFIG_KEYS[stepIndex] || 'overview';
    const StepComponent = STEP_COMPONENTS[stepKey] || OverviewStep;
    if (typeof StepComponent !== 'function') {
        return null;
    }
    return <StepComponent {...props} />;
}

export {
    OverviewStep,
    PackagesStep,
    PricingStep,
    ServicesStep,
    DeparturesStep,
    AllocationsStep,
    ItinerariesStep,
    AddonsStep,
    FaqsStep,
    ReviewStepPage,
};

export default renderWizardStep;
